<template>
  <div class="form-group" :class="{ focused: props.defaultValue != null }">
    <label :for="props.field_id">{{ props.label }}</label>
    <input :id="props.field_id" v-model="model" maxlength="100" type="text" @blur="onBlur" @focus="onFocus"
      @change="emit('change', model)" :autocomplete="props.autoFill" :class="{ 'error': props.valid.$errors.length }" />
    <span v-if="props.valid.$errors.length" class="error-message">
      {{ props.valid.$errors[0].$message }}
    </span>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { onBlur, onFocus } from './fields.js'

const props = defineProps({
  field_id: String,
  label: String,
  maxLength: String,
  type: String,
  autoFill: String,
  valid: Object,
  defaultValue: String
})

const emit = defineEmits(['change'])

const model = ref(props?.defaultValue)
if (props?.defaultValue) {
  emit('change', props?.defaultValue)
}
</script>

<style scoped></style>
